import React from 'react';
import Avatar from 'react-avatar';
import MediaQuery from 'react-responsive';
import { DropdownItem, NavLink } from 'reactstrap';
import SignoutButton from './signoutButton';
import COLORS from '../../../../common/colors';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons/faCaretUp';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
import FontAwesomeSVGIcon from '../../elements/icons/fontAwesomeSVGIcon';
import getConfig from 'next/config';
import SelectByPlatform from '../../../workplace/common/selectByPlatform';
import NavItem from 'reactstrap/lib/NavItem';

const config = getConfig().publicRuntimeConfig;

// FIXME Placement of signout

export default class UserMenu extends React.Component {
	constructor(props) {
		super(props);
		let firstName = '';
		let lastName = '';
		let name = null;
		if (this.props.session.user.firstName && this.props.session.user.firstName !== null) {
			firstName = this.props.session.user.firstName;
		}
		if (this.props.session.user.lastName && this.props.session.user.lastName !== null) {
			lastName = this.props.session.user.lastName;
		}
		if (firstName !== '' || lastName !== '') {
			name = `${firstName} ${lastName}`;
		}

		this.toggle = this.toggle.bind(this);
		const { socialLogins } = this.props.session.user;
		let socialLoginJson = {};
		if (typeof socialLogins !== 'undefined') {
			socialLogins.forEach((socialLogin) => {
				socialLoginJson[socialLogin.type] = socialLogin.loginId;
			});
		}


		this.state = {
			dropdownOpen: false,
			name: name || this.props.session.user.email,
			socialLogins: socialLoginJson,
			isProfileMenuOpen: false,
			isCauseMenuOpen: false,
			isMissionsMenuOpen: false,
			isGetInvolved: false
			
		};

	}
	toggle() {
		this.setState({
			dropdownOpen: !this.state.dropdownOpen,
		});
	}

	toggleCausesMenu = () => {
		this.setState({ 
			isCauseMenuOpen: !this.state.isCauseMenuOpen, isMissionsMenuOpen: false, isGetInvolved: false
		});
	}

	toggleMissionsMenu = () => {
        this.setState({
            isMissionsMenuOpen: !this.state.isMissionsMenuOpen, isCauseMenuOpen: false, isGetInvolved: false
        })
	}
	
	toggleIsGetInvolvedMenu = () => {
        this.setState({
            isGetInvolved: !this.state.isGetInvolved, isCauseMenuOpen: false, isMissionsMenuOpen: false
        })
    }
	async getInitialProps() {
		this.setState({
			name: this.props.session.user.name || this.props.session.user.email,
		});
	}

	toggleProfileMenu = (event) => {
		event.preventDefault();
		if (this.props.session.user && !this.props.session.user.firstName) {
			window.location.href = '/user/profile'
		} else {
			this.setState({
				isProfileMenuOpen: !this.state.isProfileMenuOpen
			})
		}
	}

	render() {
		const { session, color, width, tenantConfig, loginBackgroundColor } = this.props;

		// FIXME Forcefully adding show incase of toggle. Might be fixed with an update to Reactstrap
		// possible error in compatibility between reactstrap and bootstrap versions

		const classname = this.state.dropdownOpen ? 'show' : '';
		const { facebook, google } = this.state.socialLogins;
		return (
			<div style={{ backgroundColor: loginBackgroundColor ? loginBackgroundColor : "" }}>
				<MediaQuery maxWidth={992} device={{ width }} >
					<div>
						{session.user && <div >
							<DropdownItem toggle={false} onClick={(e) => this.toggleProfileMenu(e)} style={{
								textAlign: 'left', padding: '0.8rem', borderBottom: '1px solid rgba(0,0,0,0.1)', outline: 'none', color: color || COLORS.giveDarkGrey, display: "flex", alignItems: 'center'
							}}
							>
								<Avatar
									round
									textSizeRatio={1.5}
									size="25"
									maxInitials={2}
									facebookId={facebook}
									googleId={google}
									name={this.state.name}
									className="sb-avatar avatar-wrapper-new"
								/>
								{session.user.firstName ? <span className="user-salutation-text ml-2" style={{ textTransform: "capitalize" }}>Hello, {session.user.firstName}</span> : <span className="user-salutation-text ml-2" style={{ paddingLeft: "0.3rem" }}>My Profile</span>}
								{
									(this.state.isProfileMenuOpen) ?
										<FontAwesomeSVGIcon icon={faCaretUp} className="ml-auto" width="10" />
										:
										<FontAwesomeSVGIcon icon={faCaretDown} className="ml-auto" width="10" />
								}
							</DropdownItem>

							{this.state.isProfileMenuOpen ? <div className="user-profile-option-for-mobile">
								<a className="dark-no-hover-a no-color" href={`/user/profile`} style={{ color: color || COLORS.giveDarkGrey }} >
									<DropdownItem toggle={false} style={{
										textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid rgba(0,0,0,0.2)', height: '40px', color: color || COLORS.giveDarkGrey,
									}}
									>
										My Profile
							</DropdownItem>
								</a>
								{session.user.hasDonated && <a className="dark-no-hover-a no-color" href={`/user/donations`} style={{ color: color || COLORS.giveDarkGrey }} >
									<DropdownItem toggle={false} style={{
										textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid rgba(0,0,0,0.2)', height: '40px', color: color || COLORS.giveDarkGrey,
									}}
									>
										My Donations
							</DropdownItem>
								</a>}
								{session.user.hasDonated && session.user.hasBeneficiaryAssigned && <a className="dark-no-hover-a no-color" href={`/user/beneficiaries`} style={{ color: color || COLORS.giveDarkGrey }} >
									<DropdownItem toggle={false} style={{
										textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid rgba(0,0,0,0.2)', height: '40px', color: color || COLORS.giveDarkGrey,
									}}
									>
										My Beneficiaries
							</DropdownItem>
								</a>}
								{session.user.hasDonated && session.user.hasBeneficiaryAssigned && session.user.updates.count > 0 && <a className="dark-no-hover-a no-color" style={{ color: color || COLORS.giveDarkGrey }} href={`/user/reports`} >
									<DropdownItem toggle={false} style={{
										display: "flex", textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid rgba(0,0,0,0.2)', height: '40px', color: color || COLORS.giveDarkGrey,
									}}
									>
										Updates
								<span className="notification-alert badge alert">{this.props.session.user.updates.count}</span>
									</DropdownItem>
								</a>}
							</div> : null}
						</div>}
						{/* <a className="dark-no-hover-a no-color" href="/" style={{ color: color || COLORS.giveDarkGrey }} >
							<DropdownItem className="nav-menu-for-mobile" toggle={false} style={{
								textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid rgba(0,0,0,0.2)', height: '40px', color: color || COLORS.giveDarkGrey,
							}}
							>
								Home
							</DropdownItem>
						</a> */}
						{session.user.role === 'editor' && <a className="dark-no-hover-a no-color" href="/admin-dashboard" style={{ color: color || COLORS.giveDarkGrey }} >
							<DropdownItem className="nav-menu-for-mobile" toggle={false} style={{
								textAlign: 'left', padding: '0.8rem', cursor: 'pointer', borderBottom: '1px solid rgba(0,0,0,0.2)', outline: 'none', color: color || COLORS.giveDarkGrey,
							}}
							>
								Your Dashboard
							</DropdownItem>
						</a>}

						<DropdownItem toggle={false} onClick={() => this.toggleCausesMenu()} style={{
							textAlign: 'left', padding: '0.5rem', minHeight: '40px', borderBottom: '1px solid rgba(0,0,0,0.2)', outline: 'none', color: color || COLORS.giveDarkGrey, display: "flex", background: 'none'
						}}
						> Explore Causes

							{this.state.isCauseMenuOpen ? <FontAwesomeSVGIcon icon={faCaretUp} className="ml-auto" width="10" /> : <FontAwesomeSVGIcon icon={faCaretDown} className="ml-auto" width="10" />}
						</DropdownItem>

						{this.state.isCauseMenuOpen && tenantConfig.header && tenantConfig.header.menuLinks.map((menuLink, index) => {
							return (menuLink.heading !== 'Missions' ? (<NavLink key={index} className={`navbar-cause-link nav-menu-for-mobile`} style={color ? { color } : {}} href={menuLink.src}>
									{menuLink.heading}
								</NavLink>) : null)
						})
						}

						<SelectByPlatform>
							<NavItem name={"www"}>
							</NavItem>
							<NavItem name={'www'}>
							<DropdownItem toggle={false} onClick={() => this.toggleMissionsMenu()} style={{
									textAlign: 'left', padding: '0.5rem', minHeight: '40px', borderBottom: '1px solid rgba(0,0,0,0.2)', color: '#00000080', display: "flex", outline: 'none', background: 'none'
								}}>Missions
									{this.state.isMissionsMenuOpen ? <FontAwesomeSVGIcon icon={faCaretUp} className="ml-auto" width="10" /> : <FontAwesomeSVGIcon icon={faCaretDown} className="ml-auto" width="10" />}
								</DropdownItem>
								{this.state.isMissionsMenuOpen &&  tenantConfig.header && tenantConfig.header.menuLinks.map(link => {
								return ( link.heading === 'Missions' ? (
										link.missions.map((menuLink, index) =>{
											return <NavLink key={index} className={`navbar-cause-link`} style={color ? { color } : {}} href={menuLink.src}>
														{menuLink.heading}
													</NavLink>
										})
									) : null)
								})}
							</NavItem>	
                    	</SelectByPlatform>



						<SelectByPlatform>

							<a name="www" className="dark-no-hover-a no-color" rel="noopener noreferrer" target="_blank" href='https://workplace.giveindia.org/' style={{ color: color || COLORS.giveDarkGrey }} >
								<DropdownItem toggle={false} style={{
									textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid rgba(0,0,0,0.2)', height: '40px', color: color || COLORS.giveDarkGrey,
								}}
								>
									Workplace Giving
							</DropdownItem>
							</a>
							<a name="www" className="dark-no-hover-a no-color" href={`${config.fundraisersPlatformUrl}`} rel="noopener noreferrer" target="_blank" style={{ color: color || COLORS.giveDarkGrey }} >
								<DropdownItem toggle={false} style={{
									textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid rgba(0,0,0,0.2)', height: '40px', color: color || COLORS.giveDarkGrey,
								}}
								>
									Fundraisers
							</DropdownItem>
							</a>
							<a name="www" className="dark-no-hover-a no-color" href={`${config.oldPlatformUrl}`} rel="noopener noreferrer" target="_blank" style={{ color: color || COLORS.giveDarkGrey }} >
								<DropdownItem toggle={false} style={{
									textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid rgba(0,0,0,0.2)', height: '40px', color: color || COLORS.giveDarkGrey,
								}}
								>
									Previous Platform
							</DropdownItem>
							</a>
							<a name="www" className="dark-no-hover-a no-color" href="/aboutus" style={{ color: color || COLORS.giveDarkGrey }} >
								<DropdownItem toggle={false} style={{
									textAlign: 'left', padding: '0.5rem', borderBottom: '1px solid rgba(0,0,0,0.2)', height: '40px', color: color || COLORS.giveDarkGrey,
								}}
								>About Us
							</DropdownItem>
							</a>
						</SelectByPlatform>
						{/* <DropdownItem toggle={false} onClick={() => this.toggleIsGetInvolvedMenu()} style={{
                        		textAlign: 'left', padding: '0.5rem', minHeight: '40px', borderBottom: '1px solid rgba(0,0,0,0.2)', color: '#00000080', display: "flex", outline: 'none', background: 'none'
                            }}> Get Involved
					        {this.state.isGetInvolved ? <FontAwesomeSVGIcon icon={faCaretUp} className="ml-auto" width="10" /> : <FontAwesomeSVGIcon icon={faCaretDown} className="ml-auto" width="10" />}
                    		</DropdownItem> */}

                       	 {/* {this.state.isGetInvolved ? (
                            <>
                                <NavLink className="navbar-cause-link" style={{ color: color ? color : "#444444" }} rel="noopener noreferrer" target="_blank" href='https://workplace.giveindia.org/'>
                                        Workplace Giving
                                </NavLink>

                            </>
                        	): null} */}
						<SignoutButton session={this.props.session} _csrf={this.props._csrf} color={color} />
					</div>
				</MediaQuery>

				<style jsx global>
					{`
						.avatar-wrapper-new {
							box-shadow: 0 0 0 2px #DBDBDB !important;
							border-radius: 50% !important;
							display: inline-block !important;
							overflow: hidden !important;
							vertical-align: middle !important;
						}
					`}
				</style>
			</div>
		);
	}
}
